import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('call-widget-addon', {
  library: 'call-widget-addon'
});